import { apiRoutes } from "@constants/api-routes";
import { handleRequestWithBody } from "@utils/http-util";
import { RequestTypes } from "@enums/request-types";
import { RpUserPropertyBundle } from "@idw-types/data/axn-admin-user/rp-user-property-bundle";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { AxnAdminUserInvitation } from "@idw-types/data/axn-admin-user-invitation";

type sendAxnAdminUserInvitationRequestResponse = {
    response: AxnAdminUserInvitation;
};

export const sendAxnAdminUserInvitationRequest = async (
    email: string,
    axnCompanyId: string,
    userPropertyBundleID: string,
    rpUserPropertyBundles: Array<RpUserPropertyBundle>,
): Promise<GenericNetworkResponse<sendAxnAdminUserInvitationRequestResponse>> => {
    const route = apiRoutes.axnadminCore.user.invitation;

    const body = {
        organizationID: axnCompanyId,
        email,
        userPropertyBundleID: rpUserPropertyBundles.length > 0 ? null : userPropertyBundleID,
        rpUserPropertyBundles: rpUserPropertyBundles.length > 0 ? rpUserPropertyBundles : null
    };

    const { data, error } = await handleRequestWithBody(RequestTypes.POST, route, body);

    return { data, error, body };
};